<template>
  <v-form ref="form" @submit.prevent>
    <v-row>
      <v-col cols="12">
        <app-editor ref="editor" v-model="crud.description" />
      </v-col>
      <v-col
        cols="12"
        md="6"
        v-for="(question, index) in crud.question_group.questions"
        :key="'Question' + index"
      >
        <app-pronunciation-card
          v-model="question.question_file"
          :content.sync="question.content"
          @delete="removeQuestion(index)"
        />
      </v-col>
      <v-col cols="12">
        <app-add @new-exercise="onNewWord">Add New Word</app-add>
      </v-col>
      <v-btn text @click="onSave" :loading="loading" color="#FF347C" class="d-flex ml-auto"
        >Save</v-btn
      >
    </v-row>
  </v-form>
</template>
<script>
import { getHomeworkById } from "@/api/api";
import PronunciationCard from "../Pronunciation/PronunciationCard.vue";
import Add from "../Grammar/Add.vue";
import pronunciationMixin from "@/mixins/pronunciationMixin";
import homeworkMixin from "@/mixins/homeworkMixin";
import Editor from "../../../Utils/Editor.vue";

export default {
  components: {
    appPronunciationCard: PronunciationCard,
    appAdd: Add,
    appEditor: Editor,
  },
  mixins: [pronunciationMixin, homeworkMixin],
  async mounted() {
    if (this.data.uuid) {
      const response = await getHomeworkById(this.data.uuid);
      this.crud = {
        ...response.data,
        description: JSON.parse(response.data.description),
      };
      this.$refs.editor.setContent(this.crud.description);
    } else if (this.data) {
      let description = {
        type: "doc",
        content: [
          {
            type: "paragraph",
            content: [
              {
                type: "text",
                text: "Recording order here...",
              },
            ],
          },
        ],
      };

      this.crud = {
        ...this.data,
        description,
      };
      this.$refs.editor.setContent(this.crud.description);
    }
  },
};
</script>
